import { render } from "./MyButton.vue?vue&type=template&id=650cbf0d&scoped=true"
import script from "./MyButton.vue?vue&type=script&lang=ts"
export * from "./MyButton.vue?vue&type=script&lang=ts"

import "./MyButton.vue?vue&type=style&index=0&id=650cbf0d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-650cbf0d"

export default script